"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _styles = require("../styles");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var RebrandingProviders = function RebrandingProviders(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#4C5559' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/React.createElement(_styles.Svg, {
    width: size,
    height: size,
    fill: "none",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className, " ").concat(animation),
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.543,
    clipPath: "url(#RebrandingProvidersId)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.011 15.023a7.502 7.502 0 0 0-7.498-7.505 7.502 7.502 0 0 0-7.5 7.505v5.153a7.502 7.502 0 0 0 7.5 7.506 7.502 7.502 0 0 0 7.498-7.506v-5.153Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.386 23.03s1.773 1.477 4.254 0M25.883 17.208a7.947 7.947 0 0 1-7.428-5.115 7.947 7.947 0 0 1-7.429 5.115M11.014 21.358h-.977a2.068 2.068 0 0 1-2.07-2.069c0-1.144.926-2.069 2.07-2.069h.977M26.024 17.208H27c1.143 0 2.069.925 2.069 2.07 0 1.143-.926 2.068-2.07 2.068h-.976"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.519 33.992c8.83 0 15.987-7.158 15.987-15.987 0-8.83-7.157-15.987-15.987-15.987S2.532 9.175 2.532 18.005s7.157 15.987 15.987 15.987Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "RebrandingProvidersId"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v36H0z"
  }))));
};
var _default = exports["default"] = RebrandingProviders;